import { create } from "zustand";

interface PageTitleState {
  title: string | null;
  description: string | null;
  showInMobileHeader: boolean;
  backButtonUrl?: string;
  backButtonLabel?: string;
}

interface PageTitleActions {
  setPageTitle: (title: string, description?: string) => void;
  clearPageTitle: () => void;
  setShowInMobileHeader: (show: boolean) => void;
  setBackButton: (url: string, label: string) => void;
  clearBackButton: () => void;
}

const initialState: PageTitleState = {
  title: null,
  description: null,
  showInMobileHeader: false,
  backButtonUrl: undefined,
  backButtonLabel: undefined,
};

export const usePageTitleStore = create<PageTitleState & PageTitleActions>()(
  (set) => ({
    ...initialState,

    setPageTitle: (title: string, description?: string) => {
      set({
        title,
        description: description || null,
        showInMobileHeader: true,
      });
    },

    clearPageTitle: () => {
      set(initialState);
    },

    setShowInMobileHeader: (show: boolean) => {
      set({ showInMobileHeader: show });
    },

    setBackButton: (url: string, label: string) => {
      set({ backButtonUrl: url, backButtonLabel: label });
    },

    clearBackButton: () => {
      set({ backButtonUrl: undefined, backButtonLabel: undefined });
    },
  })
);

// Convenience hook
export const usePageTitle = () => {
  const {
    title,
    description,
    showInMobileHeader,
    backButtonUrl,
    backButtonLabel,
    setPageTitle,
    clearPageTitle,
    setBackButton,
    clearBackButton,
  } = usePageTitleStore();

  return {
    title,
    description,
    showInMobileHeader,
    backButtonUrl,
    backButtonLabel,
    setPageTitle,
    clearPageTitle,
    setBackButton,
    clearBackButton,
  };
};

export default usePageTitleStore;
